import { render, staticRenderFns } from "./Logik.vue?vue&type=template&id=ed801492&scoped=true&"
import script from "./Logik.vue?vue&type=script&lang=js&"
export * from "./Logik.vue?vue&type=script&lang=js&"
import style0 from "./Logik.vue?vue&type=style&index=0&id=ed801492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed801492",
  null
  
)

export default component.exports